import {
  useMutation,
  useQuery,
  type UseMutationResult,
  type UseQueryResult,
} from '@tanstack/react-query';
import {
  getAdminPreferredLocale,
  setAdminPreferredLocale,
  type SetAdminPreferredLocaleInput,
} from '../services/admin-preferences.service';
import type { SupportedLocale } from '../i18n';
import type { SupabaseClient } from '../supabase/client';

export const adminPreferredLocaleKeys = {
  detail: (userId: string | null) => ['admin', 'preferred-locale', userId] as const,
};

export interface UseAdminPreferredLocaleOptions {
  client: SupabaseClient;
  userId: string | null;
  enabled?: boolean;
}

export function useAdminPreferredLocale({
  client,
  userId,
  enabled = true,
}: UseAdminPreferredLocaleOptions): UseQueryResult<SupportedLocale | null> {
  return useQuery({
    queryKey: adminPreferredLocaleKeys.detail(userId),
    queryFn: () => getAdminPreferredLocale(client),
    enabled: enabled && !!userId,
    staleTime: 5 * 60 * 1000,
  });
}

export interface UseSetAdminPreferredLocaleOptions {
  client: SupabaseClient;
}

export function useSetAdminPreferredLocale({
  client,
}: UseSetAdminPreferredLocaleOptions): UseMutationResult<
  SupportedLocale,
  unknown,
  SetAdminPreferredLocaleInput
> {
  return useMutation<SupportedLocale, unknown, SetAdminPreferredLocaleInput>({
    mutationFn: (input) => setAdminPreferredLocale(client, input),
  });
}
